import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MensagemService } from '@app/shared/services/mensagem.service';
import { AuthenticationService } from '@app/shared/services';
import { CensoService } from '@app/shared/services/censo.service';

import { Censo } from '@app/shared/models';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-header-pages',
  templateUrl: './header-pages.component.html',
  styleUrls: ['./header-pages.component.scss']
})
export class HeaderPagesComponent implements OnInit {

  censo: Censo;
  cliente = environment.cliente;

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private mensagemService: MensagemService,
    private censoService: CensoService
  ) { }

  ngOnInit(): void {
    this.censo = this.censoService.retornarSessionStorage('censo');
  }

  logout(): void {
    this.mensagemService.avisoMensagemCondicional('', 'Você deseja realmente sair?', 'warning')
    .then((response) => {
      if (response.value) {
        this.auth.logout();
        this.router.navigate(['/']);
      }
    });
  }
}
